import LogoHeader from "./LogoHeader";

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  return <LogoHeader />;
};

export default Header;
